module.exports = __webpack_public_path__ + "images/toyota_small27ba9ec6bf7af602bc3b6bd29e243150.png";